import styled from "styled-components";

export const StyledChangeStatusModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  & .option-label {
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    margin-top: 0;
  }
`;
